import React from 'react'


export default function ListItems(props) {

  







  const myStyle = {
    background: 'rgba(255, 255, 255, 0.25)',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    backdropfilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    borderRadius: '10px',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    color: 'white',

  }

 

  

  return (
    <li className='flex justify-evenly mt-2 flex-row ml-5 mr-5 mb-1 border' style={myStyle}>

      <div className='basis-4/6 sm:basis-1/3 ml-10  sm:text-sm'>{`${props.name}`}</div>
      <div className='basis-1/6 sm:basis-1/3 sm:text-sm '>Price:  </div>
      <div className='basis-1/6 sm:basis-1/3 sm:text-sm text-center' style={{backgroundColor: 'blue'}}>{props.price}</div>



    </li>
  )


}
